import { Button, Col, Divider, Drawer, Row, Tooltip } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { UserInfo } from "../../../context";
import axios from "axios";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
import EditPersonal from "./EditPersonal";
import EditContact from "./EditContact";
import EditCredentials from "./EditCredentials";
// import EditCredentials from "./EditCredentials";
// import EditPersonal from "./EditPersonal";
// import EditBusiness from "./EditBusiness";
// import EditContact from "./EditContact";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);

const PasswordItem = () => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">Password:</p>
    &#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
  </div>
);

const AccountDetails = ({ open, close }) => {
  const { userData, handleRerunUser } = useContext(UserInfo);
  const [storeAdminInfo, setStoreAdminInfo] = useState({
    data: [],
    ready: false,
  });
  const [editPersonal, setEditPersonal] = useState(false);
  const [editBusiness, setEditBusiness] = useState(false);
  const [editContact, setEditContact] = useState(false);
  const [editCredentials, setEditCredentials] = useState(false);

  const getMyStoreAdminInfo = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/store-admin/my-store-admin-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setStoreAdminInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMyStoreAdminInfo();
  }, [getMyStoreAdminInfo]);

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <div style={{ flexGrow: 1 }}></div>
        <div>
          <Tooltip title="Close">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                close();
              }}
              icon={<CloseOutlined />}
            />
          </Tooltip>
        </div>
      </div>
      {storeAdminInfo.ready && (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Personal</p>
            </div>
            <div>
              <Tooltip title="Edit Personal">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    // setSelectedData(text);
                    setEditPersonal(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Full Name"
                content={
                  <span style={{ fontWeight: "bold" }}>
                    {`${
                      storeAdminInfo.data[0].firstname !== null
                        ? storeAdminInfo.data[0].firstname
                        : ""
                    } ${
                      storeAdminInfo.data[0].lastname !== null
                        ? storeAdminInfo.data[0].lastname
                        : ""
                    }`}
                  </span>
                }
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Address"
                content={`${
                  storeAdminInfo.data[0].street !== null
                    ? `${storeAdminInfo.data[0].street}, `
                    : ""
                } ${
                  storeAdminInfo.data[0].barangay !== null
                    ? `${storeAdminInfo.data[0].barangay}, `
                    : ""
                } ${
                  storeAdminInfo.data[0].city !== null
                    ? `${storeAdminInfo.data[0].city.toLowerCase()}, `
                    : ""
                } ${
                  storeAdminInfo.data[0].province !== null
                    ? storeAdminInfo.data[0].province.toLowerCase()
                    : ""
                }`}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Contacts</p>
            </div>
            <div>
              <Tooltip title="Edit Contacts">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditContact(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Email"
                content={
                  storeAdminInfo.data[0].storeadminuser.email !== null
                    ? storeAdminInfo.data[0].storeadminuser.email
                    : ""
                }
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Contact Number"
                content={
                  storeAdminInfo.data[0].contact_no !== null
                    ? storeAdminInfo.data[0].contact_no
                    : ""
                }
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Credentials</p>
            </div>
            <div>
              <Tooltip title="Edit Credentials">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditCredentials(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Username"
                content={storeAdminInfo.data[0].storeadminuser.username}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <PasswordItem />
            </Col>
          </Row>
        </>
      )}

      {editPersonal && (
        <EditPersonal
          open={editPersonal}
          close={() => setEditPersonal(false)}
          data={storeAdminInfo.ready && storeAdminInfo.data[0]}
          rerun={() => getMyStoreAdminInfo()}
        />
      )}

      {editContact && (
        <EditContact
          open={editContact}
          close={() => setEditContact(false)}
          data={storeAdminInfo.ready && storeAdminInfo.data[0]}
          rerun={() => getMyStoreAdminInfo()}
        />
      )}

      {editCredentials && (
        <EditCredentials
          open={editCredentials}
          close={() => setEditCredentials(false)}
          data={storeAdminInfo.ready && storeAdminInfo.data[0]}
          rerun={() => getMyStoreAdminInfo()}
        />
      )}
    </Drawer>
  );
};

export default AccountDetails;
